import { useSession } from "@app/session";
import { setUi, useUi } from "@app/ui";
import { DeployModal as SharedDeployModal } from "@repo/components/deploy";
import { useNavigate } from "react-router";
import { errorCode, useAnalytics } from "../../analytics";

/** Coarse reason for a rejected deploy: 409 is one of ctrl's emulator limits (per user or per tenant). */
export function deployFailureReason(err: unknown): "limit" | "other" {
  return (err as { status?: unknown } | null)?.status === 409 ? "limit" : "other";
}

/** Global deploy flow: opened from Home, Emulators, Builds and ⌘K. */
export function DeployModal() {
  const { deploy } = useUi();
  const session = useSession();
  const navigate = useNavigate();
  const { track } = useAnalytics();
  return (
    <SharedDeployModal
      opened={Boolean(deploy)}
      snapshot={deploy?.snapshot}
      onClose={() => setUi({ deploy: null })}
      viewer={session}
      onDeployed={(id) => {
        track("emulator_created", { emulator_id: id, source: "deploy_modal" });
        navigate(`/emulators/${id}`);
      }}
      onDeployFailed={(err) => {
        track("emulator_deploy_failed", {
          status: errorCode(err),
          reason: deployFailureReason(err),
          source: "deploy_modal",
        });
      }}
    />
  );
}
